import {FormControl, Stack} from '@primer/react-brand/esm'
import {ConsentExperienceInput} from './ConsentExperienceInput'

import {ConsentExperienceContext} from './ConsentExperienceContext'
import {use} from 'react'

export type ConsentExperienceProps = {
  /**
   * If `true`, the consent checkbox won't appear at all for countries that support implicit opt-in, and
   * consent will be implied if the user submits the form.
   *
   * If `false`, the checkbox will always appear and must be checked to give consent.
   *
   * Note: this prop will only have an effect in countries that support implicit opt-in (e.g. the US).
   * In other countries, the checkbox will always appear regardless of this prop's value.
   *
   * @default true
   */
  implicitOptIn?: boolean
}

/**
 * Requirements:
 * - Located inside a ConsentExperience.Provider (e.g. see App.tsx)
 * - Located alongside a CountrySelectField component
 */
export const ConsentExperience = ({implicitOptIn = true}: ConsentExperienceProps) => {
  const consentExperienceExamplesFields = ['first name', 'last name', 'company', 'email']
  const ctx = use(ConsentExperienceContext)

  return (
    <Stack direction="vertical" gap="condensed" padding="none">
      <FormControl id="form-field-consent-experience" fullWidth>
        <ConsentExperienceInput
          selectedCountry={ctx.selectedCountry ?? {name: '', alpha: ''}}
          emailSubscriptionSettingsLinkHref="/settings/emails/subscriptions/link-request/new"
          exampleFields={consentExperienceExamplesFields}
          fieldName="marketing_email_opt_in"
          privacyStatementHref="https://docs.github.com/articles/github-privacy-statement"
          implicitOptIn={implicitOptIn}
        />
      </FormControl>
    </Stack>
  )
}
